module.exports = __webpack_public_path__ + "static/media/landing_4_mobile_right.2c96ca5b.jpg";